import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M5 12h14"/>
  <path d="M12 5v14"/>
</svg>`;

const Plus = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='plus' svg={svg} {...props} />
  )
);

Plus.displayName = 'PlusIcon';

export default Plus;
